/*
  This is a global event bus that can be used for cross component event.
  Useful for when you need to trigger events without having a reference to other components.

  Returns a singleton instance of the GlobalEventBus class.
*/

define('lib/GlobalEventBus',['require','underscore','lib/backbone/Backbone.PodioEvents'],function (require) {
    var _ = require('underscore');
    var PodioEvents = require('lib/backbone/Backbone.PodioEvents');

    function GlobalEventBus(options) {
        _.extend(this, options);

        return this;
    }

    _.extend(GlobalEventBus.prototype, PodioEvents);

    return new GlobalEventBus();
});

